import React, { useEffect, useRef, useState } from "react";
import { CrossSvg } from "../assets/svg/CrossSvg";
import { SearchSvg } from "../assets/svg/SearchSvg";
import { hooks } from "../hooks";
import { getFormattedCities } from "../environment";
import { LocationSvg } from "../assets/svg/MyLocaiton";
import locationAllow from "../assets/nestfin/map.png";
import { Link } from "react-router-dom";

export const GoogleApi: React.FC = () => {
  const navigate = hooks.useNavigate();
  const [inputValue, setInputValue] = useState("");
  const [suggestions, setSuggestions] = useState<any[]>([]);
  const [selectedLocalities, setSelectedLocalities] = useState<string[]>([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const autocompleteService = useRef<any>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const [showLocationPopup, setShowLocationPopup] = useState(false);
  const [location, setLocation] = useState<{ lat: number; lng: number } | null>(
    null
  );
  const [error, setError] = useState("");

  useEffect(() => {
    const popupShown = localStorage.getItem("locationPopupShown");
    if (!popupShown) {
      setTimeout(() => {
        setShowLocationPopup(true);
      }, 2000);
      localStorage.setItem("locationPopupShown", "true");
    }
  }, []);

  const formattedCities = getFormattedCities();
  // console.log(formattedCities);
  // "Delhi, New Delhi, Mumbai, Ahmedabad"

  const [selectedCities, setSelectedCities] = useState<string[]>([]);
  const [selectedCountries, setSelectedCountries] = useState<string[]>([]);
  const [selectedLatLng, setSelectedLatLng] = useState<
    { lat: number; lon: number }[]
  >([]);

  // Initialize Google Places AutocompleteService
  useEffect(() => {
    if (!autocompleteService.current && (window as any).google) {
      autocompleteService.current = new (
        window as any
      ).google.maps.places.AutocompleteService();
    }
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle input typing
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);

    if (!autocompleteService.current) return;

    if (value.trim().length > 0) {
      autocompleteService.current.getPlacePredictions(
        {
          input: value,
          componentRestrictions: { country: "in" },
          types: ["geocode"],
        },
        (predictions: any[], status: string) => {
          if (
            status === (window as any).google.maps.places.PlacesServiceStatus.OK
          ) {
            setSuggestions(predictions);
            setShowDropdown(true);
          } else {
            setSuggestions([]);
            setShowDropdown(false);
          }
        }
      );
    } else {
      setSuggestions([]);
      setShowDropdown(false);
    }
  };

  const placesService = useRef<any>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if ((window as any).google) {
      placesService.current = new (
        window as any
      ).google.maps.places.PlacesService(document.createElement("div"));
    }
  }, []);

  useEffect(() => {
    // Load selected localities from sessionStorage
    const savedLocalities = localStorage.getItem("selectedLocality");
    if (savedLocalities) {
      try {
        const parsedLocalities: string[] = JSON.parse(savedLocalities);
        // Filter out empty strings
        setSelectedLocalities(
          parsedLocalities.filter((loc) => loc.trim() !== "")
        );
      } catch {
        if (savedLocalities.trim() !== "") {
          setSelectedLocalities([savedLocalities]);
        } else {
          setSelectedLocalities([]);
        }
      }
    }

    // Load lat/lng from sessionStorage
    const savedLatLng = localStorage.getItem("selectedLatLng");
    if (savedLatLng) {
      try {
        setSelectedLatLng(JSON.parse(savedLatLng));
      } catch {
        setSelectedLatLng([]);
      }
    }
  }, []);

  // handleUseCurrentLocation
  // const handleUseCurrentLocation = () => {
  //   if (!navigator.geolocation) {
  //     alert("Geolocation is not supported by your browser");
  //     return;
  //   }

  //   navigator.geolocation.getCurrentPosition(
  //     async (position) => {
  //       const { latitude: lat, longitude: lng } = position.coords;

  //       // Initialize Google Maps Geocoder
  //       const geocoder = new (window as any).google.maps.Geocoder();

  //       geocoder.geocode({ location: { lat, lng } }, (results: any[], status: string) => {
  //         if (status === (window as any).google.maps.GeocoderStatus.OK && results[0]) {
  //           const place = results[0];

  //           // Extract locality components
  //           let locality = "";
  //           let city = "";
  //           let country = "";
  //           const placeName = place.formatted_address;

  //           place.address_components.forEach((comp: any) => {
  //             if (comp.types.includes("sublocality") || comp.types.includes("locality")) {
  //               locality = comp.long_name;
  //             }
  //             if (comp.types.includes("administrative_area_level_2")) {
  //               city = comp.long_name;
  //             }
  //             if (comp.types.includes("country")) {
  //               country = comp.long_name;
  //             }
  //           });

  //           city = locality; // use locality as city if needed
  //           const fullString = `${placeName}, ${locality}, ${country}`;

  //           // --- Update state ---
  //           setInputValue(fullString);
  //           setSelectedLocalities((prev) => [...prev, fullString]);
  //           setSelectedLatLng((prev) => [...prev, { lat, lon: lng }]);
  //           setSelectedCities((prev) => [...prev, city]);

  //           // --- Save to storage ---
  //           // Localities
  //           const prevLocalitiesRaw = localStorage.getItem("selectedLocality");
  //           let prevLocalities: string[] = prevLocalitiesRaw ? JSON.parse(prevLocalitiesRaw) : [];
  //           const updatedLocalities = prevLocalities.includes(fullString)
  //             ? prevLocalities
  //             : [...prevLocalities, fullString];
  //           localStorage.setItem("selectedLocality", JSON.stringify(updatedLocalities));

  //           // Lat/Lng
  //           const prevLatLngRaw = localStorage.getItem("selectedLatLng");
  //           let prevLatLng: { lat: number; lon: number }[] = prevLatLngRaw ? JSON.parse(prevLatLngRaw) : [];
  //           localStorage.setItem("selectedLatLng", JSON.stringify([...prevLatLng, { lat, lon: lng }]));

  //           // Cities
  //           const prevCityRaw = localStorage.getItem("selectedCity");
  //           let prevCities: string[] = prevCityRaw ? JSON.parse(prevCityRaw) : [];
  //           const updatedCities = prevCities.includes(city) ? prevCities : [...prevCities, city];
  //           localStorage.setItem("selectedCity", JSON.stringify(updatedCities));

  //           setShowDropdown(false);
  //         } else {
  //           alert("Failed to get your location name");
  //         }
  //       });
  //     },
  //     (error) => {
  //       console.error("Geolocation error:", error);
  //       alert("Failed to fetch your location");
  //     }
  //   );
  // };

  // Handle suggestion click
  const handleSuggestionClick = (place: any) => {
    if (!placesService.current) return;

    placesService.current.getDetails(
      { placeId: place.place_id },
      (details: any, status: string) => {
        if (
          status ===
            (window as any).google.maps.places.PlacesServiceStatus.OK &&
          details
        ) {
          let locality = "";
          let city = "";
          let country = "";
          let placeName = details.name;

          // Extract address components
          details.address_components.forEach((comp: any) => {
            if (
              comp.types.includes("sublocality") ||
              comp.types.includes("locality")
            ) {
              locality = comp.long_name;
            }
            if (comp.types.includes("administrative_area_level_2")) {
              city = comp.long_name;
            }
            if (comp.types.includes("country")) {
              country = comp.long_name;
            }
          });

          // Use locality as city if you want
          city = locality;

          const fullString = `${placeName}, ${locality}, ${country}`;
          const lat = details.geometry.location.lat();
          const lon = details.geometry.location.lng();

          // --- Update state ---
          setSelectedLocalities((prev) => [...prev, fullString]);
          setSelectedLatLng((prev) => [...prev, { lat, lon }]);
          setSelectedCities((prev) => [...prev, city]);

          // --- Save in sessionStorage ---
          // Localities
          const previousLocalitiesRaw =
            localStorage.getItem("selectedLocality");
          let previousLocalities: string[] = [];
          if (previousLocalitiesRaw) {
            try {
              previousLocalities = JSON.parse(previousLocalitiesRaw);
            } catch {
              previousLocalities = [previousLocalitiesRaw];
            }
          }
          const updatedLocalities = previousLocalities?.includes(fullString)
            ? previousLocalities
            : [...previousLocalities, fullString];
          localStorage.setItem(
            "selectedLocality",
            JSON.stringify(updatedLocalities)
          );

          // Lat/Lng
          const previousLatLngRaw = localStorage.getItem("selectedLatLng");
          let previousLatLng: { lat: number; lng: number }[] = [];
          if (previousLatLngRaw) {
            try {
              previousLatLng = JSON.parse(previousLatLngRaw);
            } catch {
              previousLatLng = [];
            }
          }
          const updatedLatLng = [...previousLatLng, { lat, lon }];
          localStorage.setItem("selectedLatLng", JSON.stringify(updatedLatLng));

          // City
          // const previousCityRaw = localStorage.getItem("selectedCity");
          // let previousCities: string[] = [];
          // if (previousCityRaw) {
          //   try {
          //     previousCities = JSON.parse(previousCityRaw);
          //   } catch {
          //     previousCities = [previousCityRaw];
          //   }
          // }
          // const updatedCities = previousCities.includes(city)
          //   ? previousCities
          //   : [...previousCities, city];
          // localStorage.setItem("selectedCity", JSON.stringify(updatedCities));

          // --- Save latest city directly in localStorage ---
          // localStorage.setItem("selectedCity", city);

          // --- Save selected city and city ID in localStorage ---
          const cityIdMap: Record<string, number> = {
            delhi: 1,
            noida: 2,
            gurugram: 3,
          };

          const selectedCityId = cityIdMap[city.toLowerCase()] ?? 0;

          // Save both city name and ID
          localStorage.setItem("selectedCity", city);
          localStorage.setItem("selectedCityId", selectedCityId.toString());

          // Clear input & dropdown
          setInputValue("");
          setShowDropdown(false);

          // console.log("Selected Localities:", updatedLocalities);
          // console.log("Selected Lat/Lng:", updatedLatLng);
          // console.log("Selected Cities:", updatedCities);
        }
      }
    );
  };

  // Clear input
  const handleClearInput = () => {
    setInputValue("");
    setSuggestions([]);
    setShowDropdown(false);
    inputRef.current?.focus();
  };

  const handleRemoveChip = (loc: string) => {
    // Find the index of the locality being removed
    const indexToRemove = selectedLocalities.findIndex((l) => l === loc);
    if (indexToRemove === -1) return;

    // --- Update Localities ---
    const updatedLocalities = selectedLocalities.filter(
      (_, i) => i !== indexToRemove
    );
    setSelectedLocalities(updatedLocalities);
    localStorage.setItem("selectedLocality", JSON.stringify(updatedLocalities));

    // --- Update Lat/Lng ---
    const selectedLatLngRaw = localStorage.getItem("selectedLatLng");
    if (selectedLatLngRaw) {
      try {
        const parsedLatLng = JSON.parse(selectedLatLngRaw);
        const updatedLatLng = parsedLatLng.filter(
          (_: any, i: number) => i !== indexToRemove
        );
        setSelectedLatLng(updatedLatLng);
        localStorage.setItem("selectedLatLng", JSON.stringify(updatedLatLng));
      } catch (error) {
        console.error("Failed to parse or update selectedLatLng:", error);
      }
    }
  };

  const handleChangeCity = () => {
    localStorage.removeItem("selectedLocality");
    localStorage.removeItem("selectedLocalityFull");
    localStorage.removeItem("selectedLocalityId");
    localStorage.removeItem("selectedLatLng");
    navigate("/onbording5");
  };

  // const handleAllowLocation = () => {
  //   setShowLocationPopup(false);

  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         const lat = position.coords.latitude;
  //         const lng = position.coords.longitude;

  //         // Navigate to map picker screen
  //         navigate("/pick-location", { state: { coords: { lat, lng } } });
  //       },
  //       (err) => {
  //         console.error("Error getting location:", err);
  //         setError("Failed to fetch location. Please try again.");
  //       }
  //     );
  //   } else {
  //     setError("Geolocation is not supported by your browser.");
  //   }
  // };

  // const handleAllowLocation = () => {
  //   setShowLocationPopup(false);

  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       async (position) => {
  //         const latitude = position.coords.latitude;
  //         const longitude = position.coords.longitude;

  //         console.log("✅ User location:", latitude, longitude);

  //         // --- Step 1: Reverse geocode using Google Maps API ---
  //         try {
  //           const geocoder = new window.google.maps.Geocoder();
  //           const latlng = { lat: latitude, lng: longitude };

  //           geocoder.geocode({ location: latlng }, (results: any[], status: string) => {
  //             if (status === "OK" && results[0]) {
  //               const address = results[0].formatted_address;

  //               console.log("📍 Address found:", address);

  //               // --- Step 2: Save data to sessionStorage ---
  //               const selectedLatLng = [{ lat: latitude, lon: longitude }];
  //               const selectedLocality = [address];

  //               localStorage.setItem("selectedLatLng", JSON.stringify(selectedLatLng));
  //               localStorage.setItem("selectedLocality", JSON.stringify(selectedLocality));

  //               // --- Step 3: Navigate to search results ---
  //               navigate("/search-result");
  //             } else {
  //               console.error("❌ Reverse geocoding failed:", status);
  //               alert("Could not determine your address. Please try again.");
  //             }
  //           });
  //         } catch (error) {
  //           console.error("❌ Error with reverse geocoding:", error);
  //           alert("Something went wrong while fetching your address.");
  //         }
  //       },
  //       (err) => {
  //         console.error("❌ Error getting location:", err);
  //         alert("Failed to fetch location. Please enable GPS and try again.");
  //       }
  //     );
  //   } else {
  //     alert("Geolocation is not supported by your browser.");
  //   }
  // };

  const handleAllowLocation = () => {
    setShowLocationPopup(false);
    // console.log("handleallow location", navigator);
    console.log(navigator);
    console.log("=====");

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          console.log("✅ User location:", latitude, longitude);

          console.log("position", position);

          try {
            const geocoder = new window.google.maps.Geocoder();
            const latlng = { lat: latitude, lng: longitude };

            geocoder.geocode(
              { location: latlng },
              (results: any[], status: string) => {
                if (status === "OK" && results[0]) {
                  const address = results[0].formatted_address;

                  // --- Extract city (locality) ---
                  const addressComponents = results[0].address_components;
                  let city = "";

                  for (let component of addressComponents) {
                    if (component.types.includes("locality")) {
                      city = component.long_name;
                      break;
                    }
                  }
                  if (city == "New Delhi") {
                    city = "Delhi";
                  }
                  let selectedCityId = null;
                  if (city === "Delhi") {
                    selectedCityId = 1;
                  } else if (city === "Noida") {
                    selectedCityId = 2;
                  } else if (city === "Gurugram") {
                    selectedCityId = 3;
                  }

                  console.log("🏙️ City (vikas):", city);
                  console.log("🆔 City ID:", selectedCityId);

                  // --- Step 2: Save data to sessionStorage ---
                  const selectedLatLng = [{ lat: latitude, lon: longitude }];
                  const selectedLocality = [address];

                  localStorage.setItem(
                    "selectedLatLng",
                    JSON.stringify(selectedLatLng)
                  );
                  localStorage.setItem(
                    "selectedLocality",
                    JSON.stringify(selectedLocality)
                  );

                  localStorage.setItem("selectedCity", city);
                  localStorage.setItem(
                    "selectedCityId",
                    selectedCityId?.toString() || ""
                  );

                  // --- Step 3: Navigate to search results ---
                  navigate("/search-result");
                } else {
                  console.error("❌ Reverse geocoding failed:", status);
                  alert("Could not determine your address. Please try again.");
                }
              }
            );
          } catch (error) {
            console.error("❌ Error with reverse geocoding:", error);
            alert("Something went wrong while fetching your address.");
          }
        },
        (err) => {
          console.error("❌ Error getting location:", err);
          alert("Failed to fetch location. Please enable GPS and try again.");
        }
      );
    } else {
      // alert("Geolocation is not supported by your browser.");
      console.log("Geolocation is not supported by your browser.");
    }
  };

  const handleDenyLocation = () => {
    setShowLocationPopup(false);
  };

  // ✅ Focus input on mount
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const selectedCity = localStorage.getItem("selectedCity");

  // console.log("showDropdown :", showDropdown);
  // console.log("suggestions :", suggestions);
  return (
    <>
      <div
        className="container"
        style={{
          marginTop: 10,
          padding: "0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={require("../assets/nestfin/Nestfin_logo.png")}
          style={{ width: 150 }}
        />
      </div>
      <div className="container" style={{ marginTop: 30, padding: "10px 0" }}>
        <p
          className="headingCity"
          style={{ textAlign: "center", marginBottom: "10px" }}
        >
          You are looking to rent
        </p>
        <p style={{ textAlign: "center", fontSize: "13px" }}>
          Explore rentals that match your needs and budget.
        </p>
      </div>

      {/* INPUT BOX SEA */}
      <div
        ref={wrapperRef}
        style={{ position: "relative", width: "100%", marginTop: "20px" }}
      >
        {selectedCity && (
          <div
            style={{
              fontSize: "13px",
              marginBottom: "15px",
              borderRadius: "8px",
              fontFamily: "Arial, sans-serif",
              color: "#333",
              fontWeight: "500",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              // padding: "10px 15px",
            }}
          >
            <div>
              Selected City:{" "}
              <span style={{ color: "#000", fontWeight: "600" }}>
                {selectedCity}
              </span>
            </div>

            <Link
              to="/onbording5"
              style={{
                color: "#000000",
                fontWeight: "600",
                fontSize: "12px",
                textDecoration: "underline",
              }}
            >
              Change City
            </Link>
          </div>
        )}

        <div
          style={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #ccc",
            borderRadius: 8,
            padding: "13px 10px",
            gap: "6px",
            backgroundColor: "#fff",
          }}
        >
          <SearchSvg />

          <input
            ref={inputRef}
            type="text"
            placeholder="Search city, locality, landmark....."
            value={inputValue ?? ""}
            onChange={handleInputChange}
            onFocus={() => {
              if (inputValue.trim()) {
                setShowDropdown(true);
              }
            }}
            style={{
              border: "none",
              outline: "none",
              flex: 1,
              fontSize: 14,
            }}
          />

          {inputValue && (
            <span onClick={handleClearInput} style={{ cursor: "pointer" }}>
              <CrossSvg width={13} height={13} color="#444" />
            </span>
          )}
        </div>

        {/* {showDropdown && suggestions.length > 0 && ( */}
        {suggestions.length > 0 && (
          <ul
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              width: "100%",
              background: "#fff",
              border: "1px solid #ddd",
              borderRadius: 6,
              marginTop: 4,
              maxHeight: 220,
              overflowY: "auto",
              zIndex: 10,
            }}
          >
            {suggestions.map((s, index) => (
              <li
                key={index}
                onClick={() => handleSuggestionClick(s)}
                style={{
                  padding: "10px 12px",
                  cursor: "pointer",
                  borderBottom:
                    index === suggestions.length - 1
                      ? "none"
                      : "1px solid #f1f1f1",
                }}
                onMouseEnter={(e) =>
                  ((e.target as HTMLElement).style.backgroundColor = "#f8f8f8")
                }
                onMouseLeave={(e) =>
                  ((e.target as HTMLElement).style.backgroundColor = "#fff")
                }
              >
                {s.description}
              </li>
            ))}
          </ul>
        )}

        {/* Selected Localities Chips */}
        {selectedLocalities.length > 0 && (
          <div
            style={{
              display: "flex",
              overflowX: "auto",
              flexWrap: "nowrap",
              gap: "6px",
              margin: "18px 0",
            }}
          >
            {selectedLocalities
              .slice()
              .reverse() // to show latest added first
              .map((loc, idx) => (
                <div
                  key={idx}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "var(--secondary-color)", // or your desired color
                    borderRadius: "5px",
                    padding: "9px 10px",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    color: "white",
                  }}
                >
                  <span>{loc}</span>
                  <span
                    style={{
                      cursor: "pointer",
                      fontWeight: "bold",
                      color: "#fff",
                      marginLeft: "8px",
                    }}
                    onClick={() => handleRemoveChip(loc)}
                  >
                    ×
                  </span>
                </div>
              ))}
          </div>
        )}
      </div>

      <div>
        {/* Button */}
        <div
          className="useLocation"
          style={{ marginTop: "10px", cursor: "pointer" }}
          // onClick={() => setShowLocationPopup(true)}
          onClick={handleAllowLocation}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2C12.5523 2 13 2.44772 13 3V5.07003C16.3925 5.55468 18.9453 8.10754 19.43 11.5H21C21.5523 11.5 22 11.9477 22 12.5C22 13.0523 21.5523 13.5 21 13.5H19.43C18.9453 16.8925 16.3925 19.4453 13 19.93V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V19.93C7.60754 19.4453 5.05468 16.8925 4.57 13.5H3C2.44772 13.5 2 13.0523 2 12.5C2 11.9477 2.44772 11.5 3 11.5H4.57C5.05468 8.10754 7.60754 5.55468 11 5.07003V3C11 2.44772 11.4477 2 12 2ZM12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7Z"
              fill="var(--secondary-color)"
            />
          </svg>
          <span style={{ marginLeft: 6 }}>Use My Current Location </span>
        </div>

        {/* Popup */}
        {showLocationPopup && (
          <div className="location-overlay">
            <div className="location-modal">
              <div className="location-buttons">
                <div className="img-container">
                  <img src={locationAllow} alt="Location" width="100" />
                </div>
                <div className="locationContent">
                  <h3>Allow your location </h3>
                  <p>
                    To help you find the best options near you, we need access
                    to your location. Your privacy is important to us.
                  </p>
                </div>
                <button className="allow-btn" onClick={handleAllowLocation}>
                  Allow{" "}
                </button>
                <button className="deny-btn" onClick={handleDenyLocation}>
                  Don't Allow
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Google Map */}
        {location && (
          <div style={{ marginTop: 20 }}>
            <h4>Your Location:</h4>
            <p>
              Latitude: {location.lat}, Longitude: {location.lng}
            </p>
            <iframe
              title="map"
              width="100%"
              height="300"
              style={{ borderRadius: 10 }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              src={`https://www.google.com/maps?q=${location.lat},${location.lng}&hl=es;z=14&output=embed`}
            ></iframe>
          </div>
        )}

        {/* Error */}
        {error && <p style={{ color: "red" }}>{error}</p>}
      </div>
    </>
  );
};

// Basic styles
const overlayStyle: React.CSSProperties = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0,0,0,0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

const modalStyle: React.CSSProperties = {
  background: "#fff",
  borderRadius: 10,
  padding: 20,
  maxWidth: 400,
  textAlign: "center",
};
